/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueSweetalert2 from 'vue-sweetalert2';
import VueClipboards from 'vue-clipboards';
import VueI18n from 'vue-i18n'
import URI from 'urijs';
import VTooltip from 'v-tooltip'
import VueTheMask from 'vue-the-mask';
import Ripple from 'vue-ripple-directive'

Vue.component('icon', () => import('./icons'));

import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, {
    siteKey: '6LdGXvcUAAAAAMA_n0UMNd4qctf4z5CPMLTwQ7dF',
    loaderOptions: {
        autoHideBadge: true
    }
});

Vue.use(VueTheMask);
Vue.use(VueSweetalert2);
Vue.use(VueResource);
Vue.use(VueClipboards);
Vue.use(VueI18n);
Vue.use(VTooltip);

Ripple.color = 'rgba(255, 255, 255, 0.15)';

Vue.directive('ripple', Ripple);
Vue.config.productionTip = false;

String.prototype.pathname = function()
{
    var uri = URI(this);
    return (uri.pathname() + uri.search()).substr(0, 20);
};

var api = 'https://likemania.com/api2/';
/*
if(Vue.config.productionTip)
{
    api = 'https://likemania.com/api2/';
}*/

Vue.http.options = {
    root: api,
};

Vue.directive('scroll', {
    inserted: function (el, binding) {
        let f = function (evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f)
            }
        }
        window.addEventListener('scroll', f)
    }
});

const messages = {
    en: {
        messages: {
            currency: '$',
            lang: 'RU',
            install: {
                title: 'Install our app',
                ios1: 'Share button\n' +
                    '<img data-v-15a1121b="" alt="Share Button Image" height="10" width="10" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy5\n' +
                    '3My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMC44OCAyNy4yNSI+PGRlZnM+PHN0eWxlPi\n' +
                    '5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMyMzFmMjA7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5TY\n' +
                    'WZhcmlfU2hhcmU8L3RpdGxlPjxwb2x5bGluZSBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTMuMTMg\n' +
                    'OCAyMC4zOCA4IDIwLjM4IDI2Ljc1IDAuNSAyNi43NSAwLjUgOCA3LjUgOCIvPjxsaW5lIGNsYXN\n' +
                    'zPSJjbHMtMSIgeDE9IjEwLjQ0IiB5MT0iMTciIHgyPSIxMC40NCIvPjxsaW5lIGNsYXNzPSJjbH\n' +
                    'MtMSIgeDE9IjEwLjQ4IiB5MT0iMC4zOCIgeDI9IjE1LjI4IiB5Mj0iNS4xOCIvPjxsaW5lIGNsY\n' +
                    'XNzPSJjbHMtMSIgeDE9IjEwLjQ0IiB5MT0iMC4zOCIgeDI9IjUuNjQiIHkyPSI1LjE4Ii8+PC9z\n' +
                    'dmc+"> at the bottom of the browser',
                ios2: 'Scroll left (if needed) to find the Add to Home Screen button\n' +
                    '<img data-v-15a1121b="" alt="Add to Home Screen button Image" height="10" width="10" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy5\n' +
                    '3My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNSAzNSI+PHRpdGxlPlNhZmFyaV9BMkhTPC\n' +
                    '90aXRsZT48cmVjdCB3aWR0aD0iMzUiIGhlaWdodD0iMzUiIHJ4PSI4IiByeT0iOCIgc3R5bGU9I\n' +
                    'mZpbGw6IzhmOGY4ZiIvPjxsaW5lIHgxPSIyNC43NSIgeTE9IjE3LjUiIHgyPSIxMC4yNSIgeTI9\n' +
                    'IjE3LjUiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOiNmZmY7c3Ryb2tlLXdpZHRoOjJweCIvPjx\n' +
                    'saW5lIHgxPSIxNy41IiB5MT0iMTAuMjUiIHgyPSIxNy41IiB5Mj0iMjQuNzUiIHN0eWxlPSJmaW\n' +
                    'xsOm5vbmU7c3Ryb2tlOiNmZmY7c3Ryb2tlLXdpZHRoOjJweCIvPjwvc3ZnPg==">'
            },
            save: {
                load: 'Load',
                save: 'Save',
                label: 'Enter your Instagram login',
                label2: 'Select the photos you want and click save',
                success: 'Images saved to photos'
            },
            alerts: {
                confirm: {
                    title: 'Are you sure?',
                    text: 'This operation can not be canceled!',
                    remove: 'Delete',
                    cancel: 'Cancel',
                    removesuccesstitle: 'Deleted!',
                    removesuccesstext: 'Order was successfully deleted.'
                },
                error: 'Error',
                servererror: 'Server is not available'
            },
            gift: {
                url: '/p/9ztjgAuS4t/',
                url_label: 'provide a link to the video',
                email: 'email',
                email_label: 'enter your email',
                submit: 'Get a gift',
                title: '1,000 views for free',
                notify: 'gift will be delivered only after activation by email',
                success_title: 'Ready',
                success_text: 'The letter with the activation of the gift was sent to the email.'
            },
            registationmodal: {
                title: 'Successful registration!',
                text: 'You have successfully registered. copy and save the password. It is also sent to your email.',
                copy: 'Copy',
                cancel: 'Close'
            },
            passwordmodal: {
                title: 'Change Password',
                current: 'Current password',
                'new': 'New password',
                change: 'Change',
                cancel: 'Cancel'
            },
            smsmodal: {
                title: 'Auto likes have been successfully ordered',
                text: 'Enter your phone number, we will send SMS notifications about the end of auto likes',
                textcode: 'The code has been sent to the phone number you entered. Enter it in the box below.',
                phone: 'Phone',
                code: 'Activation code',
                change: 'Submit',
                cancel: 'Close',
                success: 'You have successfully received a discount',
                error_phone: 'Enter a valid phone number',
                error_code: 'Enter the correct activation code',
            },
            login: {
                title: 'Sign in',
                text: 'Sign in using social networks',
                email: 'Email',
                password: 'Password',
                registration: 'Sign up',
                login: 'Sign in',
                recovery: 'Forgot your password?',
                loginsubmit: 'Sign in',
                registrationsubmit: 'Sign up',
                recoverysubmit: 'Forgot Password',
                error: 'Error!',
                success: 'Thank you!',
                passwordwrong: 'Incorrect password',
                registrationsuccess: 'You have successfully registered. Password sent to email.',
                recoverysuccess: 'Password recovery link sent to email',
                checkbox: 'I accept the <a href="/user-agreement.pdf" target="_blank">terms of the public offer and user agreement</a> and give my <a href="/data-processing-consent.pdf" target="_blank">consent to the processing of personal data</a> in accordance with the <a href="/privacy-policy.pdf" target="_blank">Privacy Policy</a>.',
            },
            order: {
                username: 'Comment author login',
                web: 'Select social network',
                service: 'Select service',
                addblock: 'You can also add:',
                reach_need: 'Reach & impressions',
                reach_info: 'Number of reach & impressions',
                saves_need: 'Saves',
                saves_info: 'Number of saves',
                url_loading: 'Verifying the link',
                url_good: 'It\'s all right, place an order',
                email: 'Email',
                live: 'Real',
                robots: 'Robots',
                live2: 'Real',
                robots2: 'Robots',
                old: 'The last',
                news: 'The future',
                likes: 'Likes',
                views: 'Views',
                days: 'Days',
                amount: 'Quantity',
                comments: 'Comments',
                comments_info: '{comments} comments on every post',
                random: 'Random',
                random_tooltip: 'You will get a random number of likes, views and comments. For example, 10% means that for first publication you get 90 likes, for the second 110, for the third 95, 105, 96, 104, etc.',
                random_message: 'for a random number should be more than {number} pcs.',
                random_need: 'Random number',
                comments_need: 'Comments',
                comments_text: 'comment text (each new line)',
                comments_error: 'need {number} comments',
                type: 'Type',
                subscribe: '{amount} likes on each of the {old} last and {news} future',
                subscribe2: '{amount} views on each of the {old} last and {news} future videos',
                subscribest: '{amount} likes on each of the {news} future posts',
                subscribest2: '{amount} views on each of the {news} future videos',
                package: '{likes} likes and {views} views for  {days} days',
                tasksuccess: 'Order successfully added',
                subscribesuccess: 'Subscription successfully added',
                packagesuccess: 'Subscription successfully added',
                instagramsuccess: 'Do not close the profile with privacy settings and do not change the login, this will stop the order',
                check: 'click on the link to check',
                arrow: 'Click to order',
                arrow_info: 'Want a price of {cost} rubles?',
                arrow_info2: 'How to increase the discount?',
                avatar: {
                    title: 'Add an avatar',
                    text: 'Promotion of empty pages is impossible. Do not change the login in instagram. This causes the order to stop.',
                    cancel: 'Cancel',
                    confirm: 'I added an avatar'
                },
                private: {
                    title: 'The page is hidden by privacy settings',
                    text: 'Promotion of private pages is impossible, disable privacy settings. Do not change the login in instagram. This causes the order to stop.',
                    text2: 'The profile has an age limit, you need to disable it in the Settings »Author» Minimum Age.',
                    label: 'Closed profile',
                    label2: 'Profile is limited to 18+',
                    label3: 'This service does not work for IGTV',
                    cancel: 'Cancel',
                    confirm: 'I turned off privacy settings'
                },
                error: {
                    title: 'Error',
                    text: 'Maybe link entered with error or not available',
                    cancel: 'Cancel',
                    confirm: 'Place order'
                },
                followers_error: 'To order real followers your group must have minimum 100 subscribers. Order 100 bots and add more posts. After that, you can order real followers',
            },
            tasks: {
                title: 'My orders',
                filter: 'Filter',
                search: 'Search',
                noorder: 'You have no orders',
                type: 'Type',
                vkbtn: 'The profile is private. How to fix?',
                vktext: 'У вашего профиля установлены ограничения. Откройте настройки » приватность » прочее » кому в интернете видна моя страница (установите Всем) и нажмите на зелёную кнопку для запуска заказа.',
                buttons: {
                    start: 'Launch an order',
                    start2: 'Restart order',
                    handle: 'Speed up',
                    remove: 'Delete the order',
                    remove2: 'You can delete the order within {time} sec.',
                    list: 'List of posts',
                    pay: 'Pay for the order',
                    refill: 'Disable refill for 30 days',
                    refill2: 'Enable refill for 30 days',
                },
                status: {
                    text: 'Status',
                    all: 'All',
                    progress: 'Pending',
                    done: 'Completed'
                },
                report: {
                    title: 'Send bug report',
                    cancel: 'Cancel',
                    send: 'Send',
                    placeholder: 'Write something...',
                }
            },
            partners: {
                title: 'Affiliate',
                tooltip: 'To request payment, you need to attract at least 20 customers',
                procent: '{procent}% from each payment',
                noorder: 'You do not have any partners',
                noorder2: 'Unpaid partners: 0',
                phone: 'Enter your Qiwi wallet number',
                change: 'Edit',
                copy: 'Copy',
                order: 'Order Payment',
                all: 'All',
                unpaid: 'Unpaid',
                ordersuccess: 'Payout successfully ordered',
                history: {
                    title: 'Payment history',
                    text: 'History'
                }
            },
            payment: {
                title: 'Add funds',
                order: 'Pay',
                discount: 'The more you add funds to the balance, the lower prices in instagram. Maximum discount of 50% if the total amount of replenishments exceeds 50,000 rubles',
                discount2: 'When you add funds to the balance for {number} thousand rubles all prices in the instagram will become cheapes  {proc}%.',
                cancel: 'Cancel',
                next: 'Other payment options',
                wait: 'Waiting for payment ...',
                success: 'Successfully paid',
                phone: 'Phone number',
                go: 'Proceed to checkout',
                send: 'Checkout',
                close: 'Close',
                all: 'All payment options',
                payin1: 'Add funds in $',
                payin2: 'Add funds in Rub',
                cantpay: `🚀 Save your time. Deposit more and the orders will be paid from the balance. \nCan't pay? Contact us via <u>WhatsApp</u> or <u>Telegram</u>`,
                promo_button: 'Enter promotion code',
                promo_placeholder: 'Enter a promo code for bonus',
                promo_success: 'Success! Funds will be added with a {proc}% bonus',
                promo_error: 'Invalid promo code, try again or enter another promo code',
            },
            user: {
                discount: 'discount',
                payment: 'add funds',
                menu: {
                    payment: 'Add funds',
                    history: 'Payment history',
                    password: 'Change password',
                    logout: 'Logout'
                }
            },
            menu: {
                order: 'Order',
                tasks: 'Tasks',
                help: 'Help',
                login: 'Login',
                settings: 'Settings',
                news: 'News',
                save: 'Save',
                gift: 'Gift',
            },
            help: 'Help',
            date: 'Date',
            sum: 'Amount',
            close: 'Close',
            download: 'download our app',
        },
    },
    ru: {
        messages: {
            currency: '₽',
            install: {
                title: 'Установить наше приложение',
                ios1: 'Нажмите кнопку Поделиться ' +
                    '<img data-v-15a1121b="" alt="Share Button Image" height="10" width="10" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy5\n' +
                    '3My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMC44OCAyNy4yNSI+PGRlZnM+PHN0eWxlPi\n' +
                    '5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMyMzFmMjA7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5TY\n' +
                    'WZhcmlfU2hhcmU8L3RpdGxlPjxwb2x5bGluZSBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTMuMTMg\n' +
                    'OCAyMC4zOCA4IDIwLjM4IDI2Ljc1IDAuNSAyNi43NSAwLjUgOCA3LjUgOCIvPjxsaW5lIGNsYXN\n' +
                    'zPSJjbHMtMSIgeDE9IjEwLjQ0IiB5MT0iMTciIHgyPSIxMC40NCIvPjxsaW5lIGNsYXNzPSJjbH\n' +
                    'MtMSIgeDE9IjEwLjQ4IiB5MT0iMC4zOCIgeDI9IjE1LjI4IiB5Mj0iNS4xOCIvPjxsaW5lIGNsY\n' +
                    'XNzPSJjbHMtMSIgeDE9IjEwLjQ0IiB5MT0iMC4zOCIgeDI9IjUuNjQiIHkyPSI1LjE4Ii8+PC9z\n' +
                    'dmc+"> внизу браузера',
                ios2: 'Прокрутите влево (если необходимо), чтобы найти кнопку На экран домой\n' +
                    '<img data-v-15a1121b="" alt="Add to Home Screen button Image" height="10" width="10" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy5\n' +
                    '3My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNSAzNSI+PHRpdGxlPlNhZmFyaV9BMkhTPC\n' +
                    '90aXRsZT48cmVjdCB3aWR0aD0iMzUiIGhlaWdodD0iMzUiIHJ4PSI4IiByeT0iOCIgc3R5bGU9I\n' +
                    'mZpbGw6IzhmOGY4ZiIvPjxsaW5lIHgxPSIyNC43NSIgeTE9IjE3LjUiIHgyPSIxMC4yNSIgeTI9\n' +
                    'IjE3LjUiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOiNmZmY7c3Ryb2tlLXdpZHRoOjJweCIvPjx\n' +
                    'saW5lIHgxPSIxNy41IiB5MT0iMTAuMjUiIHgyPSIxNy41IiB5Mj0iMjQuNzUiIHN0eWxlPSJmaW\n' +
                    'xsOm5vbmU7c3Ryb2tlOiNmZmY7c3Ryb2tlLXdpZHRoOjJweCIvPjwvc3ZnPg==">'
            },
            save: {
                label: 'Укажите ваш логин в Instagram',
                label2: 'Выберите нужные фото и нажмите сохранить',
                load: 'Загрузить',
                save: 'Сохранить',
                success: 'Изображения сохранены в ваш фотоальбом'
            },
            lang: 'EN',
            alerts: {
                confirm: {
                    title: 'Вы уверены?',
                    text: 'Эту операцию нельзя отменить!',
                    remove: 'Удалить',
                    cancel: 'Отменить',
                    removesuccesstitle: 'Удалено!',
                    removesuccesstext: 'Заказ был успешно удален.',
                },
                error: 'Ошибка',
                servererror: 'Нет доступа к серверу'
            },
            gift: {
                url: '/p/9ztjgAuS4t/',
                url_label: 'укажите ссылку на видео',
                email: 'email',
                email_label: 'укажите email',
                submit: 'Получить',
                title: '1 000 просмотров на одно видео',
                notify: 'подарок будет доставлен только после активации по емайл',
                success_title: 'Готово',
                success_text:  'Письмо с активацией подарка отправлено на почту.'
            },
            registationmodal: {
                title: 'Успешная регистрация!',
                text: 'Вы успешно зарегистрировались скопируйте и сохраните пароль. Он так же отправлен на указанный вами email.',
                copy: 'Копировать',
                cancel: 'Закрыть',
            },
            passwordmodal: {
                title: 'Смена пароля',
                current: 'Текущий пароль',
                new: 'Новый пароль',
                change: 'Сменить',
                cancel: 'Отмена',
            },
            smsmodal: {
                title: 'Авто лайки успешно оформлены',
                text: 'Укажите номер вашего телефона, мы будем присылать смс уведомления об окончании авто лайков.',
                textcode: 'Код был выслан на введенный вами номер телефона. Введите его в поле ниже.',
                phone: 'Телефон',
                code: 'Код активации',
                change: 'Отправить',
                cancel: 'Закрыть',
                success: 'Вы успешно получили скидку',
                error_phone: 'Введите корректный номер телефона',
                error_code: 'Введите правильный код активации',
            },
            login: {
                title: 'Вход',
                text: 'Войдите используя социальные сети',
                email: 'Email',
                password: 'Пароль',
                registration: 'Регистрация',
                login: 'Вход',
                recovery: 'Забыли пароль?',
                loginsubmit: 'Войти',
                registrationsubmit: 'Зарегистрироваться',
                recoverysubmit: 'Восстановить',
                error: 'Ошибка!',
                success: 'Спасибо!',
                passwordwrong: 'Неверный пароль',
                registrationsuccess: 'Вы успешно зарегистрировались. Пароль отправлен на email.',
                recoverysuccess: 'Ссылка для восстановление пароля отправлена на email',
                checkbox: 'Я принимаю <a href="/user-agreement.pdf" target="_blank">условия публичной оферты и пользовательского соглашения</a>\n' +
                    ' и даю <a href="/data-processing-consent.pdf" target="_blank">согласие на обработку персональных данных</a>\n' +
                    ' в соответствии с <a href="/privacy-policy.pdf" target="_blank">Политикой конфиденциальности</a>.'
            },
            order: {
                addblock: 'Так же вы можете добавить:',
                username: 'Логин автора комментария',
                service: 'Выберите услугу',
                web: 'Выберите соц. сеть',
                url_loading: 'Ссылка проверяется',
                url_good: 'Всё в порядке, оформляйте заказ',
                email: 'Email',
                live: 'Живые',
                robots: 'Роботы',
                live2: 'Живые',
                robots2: 'Роботы',
                old: 'Последних',
                news: 'Будущих',
                likes: 'Лайков',
                views: 'Просмотров',
                days: 'Дней',
                amount: 'Количество',
                comments: 'Комментарии',
                comments_info: 'по {comments} комментариев на каждую запись',
                comments_error: 'Нужно написать {number} комментариев',
                random: 'Случайное количество',
                type: 'Тип',
                saves_need: 'Сохранения',
                saves_info: 'Количество сохранений',
                reach_need: 'Охват и показы',
                reach_info: 'Количество охвата и показов',
                comments_need: 'Комментарии',
                random_need: 'Случайное количество',
                comments_text: 'текст комментариев (каждый с новой строки)',
                random_tooltip: 'Вы будете получать случайное количество лайков, просмотров и комментариев. К примеру, 10% означает что для одной публикации вы получите 90 лайков, для второй 110, для третьей 95, 105, 96, 104 и т.д.',
                random_message: 'для случайного количества должно быть больше {number} шт.',
                subscribe: 'по {amount} лайков на {old} последних и {news} будущих',
                subscribe2: 'по {amount} просмотров на {old} последних и {news} будущих видео',
                subscribest: 'по {amount} лайков на {news} будущих записей',
                subscribest2: 'по {amount} просмотров на {news} будущих видео',
                package: 'по {likes} лайков и {views} просмотров на {days} дней',
                tasksuccess: 'Заказ успешно добавлен',
                subscribesuccess: 'Подписка успешно добавлена',
                packagesuccess: 'Подписка успешно добавлена',
                instagramsuccess: 'Не закрывайте профиль настройками приватности и не меняйте логин, это приводит к остановке заказа',
                check: 'нажмите на ссылку чтобы проверить',
                arrow: 'Нажмите чтобы заказать',
                arrow_info: 'Хотите цену {cost} р.?',
                arrow_info2: 'Как повысить скидку?',
                avatar: {
                    title: 'Добавьте аватар',
                    text: 'Продвижение пустых страниц невозможно. Не меняйте логин в instagram. Это приводит к остановке заказа.',
                    cancel: 'Отменить',
                    confirm: 'Я добавил(а) аватар',
                },
                private: {
                    title: 'Страница закрыта',
                    text: 'Продвижение закрытых страниц невозможно, отключайте настройки приватности. Не меняйте логин в instagram. Это приводит к остановке заказа.',
                    text2: 'Профиль имеет ограничение по возрасту, нужно отключить его в разделе Настройки » Автор » Минимальный возраст.',
                    label: 'Закрытый профиль',
                    label2: 'Профиль ограничен 18+',
                    label3: 'Эта услуга не работает для IGTV',
                    cancel: 'Отменить',
                    confirm: 'Я открыл(а) страницу',
                },
                error: {
                    title: 'Ошибка',
                    text: 'Возможно, ссылка указана с ошибкой или недоступна, вы можете принудительно оформить заказ если уверены в правильности',
                    cancel: 'Отменить',
                    confirm: 'Заказать',
                },
                followers_error: 'В группе должно быть как минимум 100 подписчиков. Оформите для начала 100 ботов и добавьте побольше постов. После этого вы сможете оформить живых подписчиков',
            },
            tasks: {
                title: 'Мои заказы',
                filter: 'Фильтр',
                search: 'Поиск',
                noorder: 'У вас нет заказов',
                type: 'Тип',
                vkbtn: 'Профиль скрыт. Как исправить?',
                vktext: 'У вашего профиля установлены ограничения. Откройте настройки » приватность » прочее » кому в интернете видна моя страница (установите Всем) и нажмите на зелёную кнопку для запуска заказа.',
                buttons: {
                    start: 'Запустить подписку',
                    start2: 'Перезапустить заказ',
                    handle: 'Ускорить',
                    remove: 'Удалить заказ',
                    remove2: 'Удалить заказ с возвратом средств, осталось {time} сек',
                    list: 'Список постов',
                    pay: 'Оплатить заказ',
                    refill: 'Отключить авто докрутку в течение 30 дней',
                    refill2: 'Включить авто докрутку в течение 30 дней',
                },
                status: {
                    text: 'Статус',
                    all: 'Все',
                    progress: 'В процессе',
                    done: 'Выполнен',
                },
                report: {
                    title: 'Отправить отчет об ошибке',
                    cancel: 'Отмена',
                    send: 'Отправить',
                    placeholder: 'Напишите сообщение...',
                },
            },
            partners: {
                title: 'Партнёрка',
                tooltip: 'Чтобы запросить выплату нужно привлечь как минимум 20 клиентов',
                procent: '{procent}% с каждого пополнения',
                noorder: 'У вас нет партнеров',
                noorder2: 'Неоплаченных партнёров: 0 шт.',
                phone: 'Номер банковской карты',
                change: 'Изменить',
                copy: 'Копировать',
                order: 'Заказать выплату',
                ordersuccess: 'Выплата успешно заказана',
                all: 'Все',
                unpaid: 'Неоплаченные',
                history: {
                    title: 'История выплат',
                    text: 'История'
                },
            },
            payment: {
                title: 'Пополнить баланс',
                order: 'Оплатить',
                discount: 'Чем больше пополняете » тем ниже цены в instagram. Максимальная скидка 50% если общая сумма пополнений превысит 50 000 рублей',
                discount2: 'При пополнении баланса на {number} тысяч рублей все цены в instagram станут ниже на {proc}%.',
                cancel: 'Отмена',
                next: 'Другие варианты оплаты',
                wait: 'Ожидаем оплату счета...',
                success: 'Успешно оплачено',
                phone: 'Номер телефона',
                go: 'Перейти к оплате',
                send: 'Оформить заказ',
                close: 'Закрыть',
                all: 'Все варианты оплаты',

                payin1: 'Оплатить в рублях',
                payin2: 'Оплатить в $',
                cantpay: `🚀 Экономьте своё время. Пополняйте с запасом и заказы будут оплачены с баланса. <br/>Не можете оплатить? Напишите нам в <u>WhatsApp</u> или <u>Telegram</u>`,

                promo_button: 'Введите промокод',
                promo_placeholder: 'Укажите промокод для бонуса',
                promo_success: 'Получилось! Ваш баланс будет пополнен с бонусом {proc}%',
                promo_error: 'Промокод недействителен, попробуйте ещё раз или введите другой промокод',
            },
            user: {
                discount: 'скидка',
                payment: 'пополнить баланс',
                menu: {
                    payment: 'Пополнить баланс',
                    history: 'История платежей',
                    password: 'Сменить пароль',
                    logout: 'Выйти',
                },
            },
            menu: {
                order: 'Оформить',
                tasks: 'Заказы',
                settings: 'Настройки',
                help: 'Поддержка',
                news: 'Новости',
                login: 'Вход',
                save: 'Сохранить',
                gift: 'Подарок',
            },
            help: 'Поддержка',
            date: 'Дата',
            sum: 'Сумма',
            close: 'Закрыть',
            download: 'скачайте наше приложение',
        },
    }
};

const i18n = new VueI18n({
    locale: 'ru',
    messages,
});

new Vue({
    render: h => h(App),
    i18n,
}).$mount('#app');
